import { FracGroupSisterPadBase } from './base/frac-group-sister-pad-base';

export class FracGroupSisterPad extends FracGroupSisterPadBase { }